import * as React from 'react';
import Modal from 'antd/lib/modal';
import Button from 'antd/lib/button';
import withStyles from 'react-jss';
import { StylesProps } from 'src/Library/Types';
import { tokens } from 'src/design-system';

const styles = (theme) => ({
  revokeInquiryModal: {
    '& .ant-modal-title': {
      fontSize: `${tokens.fontSize.h3}px`,
      color: '#424242',
      fontWeight: tokens.fontWeight.semibold,
    },
    '& .ant-modal-body': {
      padding: 0,
    },
  },
  modalFooterText: {
    marginBottom: '18px',
    fontStyle: 'italic', 
    textAlign: 'left', 
    marginLeft: '8px', 
    color: '#424242'
  }
});

interface IProps extends
  StylesProps<ReturnType<typeof styles>>{
  visible: boolean;
  handleCancel: () => void;
  handleAddBid: () => void;
}

const FFRevokeInquiryModal = (props: IProps) => {
  const {
    visible,
    handleCancel,
    handleAddBid,
    classes
  } = props;


  const renderRevokeData = () => {
    return (
      <div
        style={{
          fontSize: tokens.fontSize.body,
          letterSpacing: '0.17px',
          lineHeight: '18px',
        }}
      >
        <div style={{padding: '16px 24px', color:'#424242'}}>
            Are you sure you want to Revoke & Add Bid for this inquiry?
        </div>
      </div>
    );
  };

  return (
    <Modal
      className={classes.revokeInquiryModal}
      width={360}
      title="Revoke & Add Bid"
      visible={visible}
      style={{ padding: '0' }}
      onCancel={handleCancel}
      footer={[
          <div className={classes.modalFooterText}>
            Note : You will be redirected to Add Bid Form after your confirmation. 
          </div>,
        <a onClick={handleCancel} style={{ color: '#424242', marginRight: '16px' }}>
          No
        </a>,
        <Button
          key="submit"
          type="primary"
          onClick={handleAddBid}
          style={{
            background: tokens.colors.primary,
            border: tokens.colors.primary,
            color: tokens.colors.bgWhite,
          }}
        >
          Yes
        </Button>,
      ]}
    >
      {renderRevokeData()}
    </Modal>
  );
};


export default withStyles(styles)(React.memo(FFRevokeInquiryModal));
